import React, { useState } from "react";
import "../styles/Header.css";
import { useLanguage } from "../contexts/LanguageContext";

const Header = () => {
  const { text, language, toggleLanguage } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="header" aria-label="Primary">
      <div className="header-inner">
        <a href="#home" className="brand" aria-label={text.brand}>
          <span className="brand-mark" aria-hidden="true">
            <svg viewBox="0 0 32 32" fill="none">
              <defs>
                <linearGradient id="brandGrad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#1d1d1f" />
                  <stop offset="0.55" stopColor="#3a3a3d" />
                  <stop offset="1" stopColor="#1d1d1f" />
                </linearGradient>
                <linearGradient id="brandShine" x1="0" y1="0" x2="0" y2="32" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stopColor="#ffffff" stopOpacity="0.32" />
                  <stop offset="0.5" stopColor="#ffffff" stopOpacity="0.05" />
                  <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
              </defs>
              <rect x="0.5" y="0.5" width="31" height="31" rx="9" fill="url(#brandGrad)" />
              <rect x="0.5" y="0.5" width="31" height="31" rx="9" fill="url(#brandShine)" />
              <path d="M9 23 V9 L23 23 V9" stroke="#f5f5f7" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </span>
          <span className="brand-name">{text.brand}<span className="brand-dot">.</span></span>
        </a>

        <button
          className={`nav-burger ${menuOpen ? "is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`header-nav ${menuOpen ? "is-open" : ""}`}>
          {text.nav.map((item) => (
            <a
              key={item.anchor}
              href={`#${item.anchor}`}
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}

          <a
            href="#contact"
            className="nav-cta"
            onClick={() => setMenuOpen(false)}
          >
            {language === "he" ? "בואו נדבר" : "Start"}
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2">
              <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>

          <div className="language-toggle" role="group" aria-label="Language">
            <button
              type="button"
              className={`lang ${language === "en" ? "active" : ""}`}
              onClick={() => toggleLanguage("en")}
            >
              EN
            </button>
            <button
              type="button"
              className={`lang ${language === "he" ? "active" : ""}`}
              onClick={() => toggleLanguage("he")}
            >
              עב
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
